import { UseFormReturn } from 'react-hook-form';

import { AllEnums, Enum, EnumListKey } from '~/data/enums';
import { LegalEntity, getCountryByLegalEntity } from '~/data/legalEntity';
import { filterActiveEnumsByCountryAndOrgUnits } from '~/utils/helper';

import { Form } from './ScheduleChanges/useScheduleChanges';

export const getTranslationKeyForObjectKey = <T>(
  key: string,
  ObjectKeyTranslation: T,
) => ObjectKeyTranslation[key as keyof T];

type Field = {
  name: string;
  enum: Enum[];
};

export const resetEnumsFormValues = (
  legalEntityValue: string | undefined,
  organizationUnitValue: number,
  allEnums: AllEnums,
  index: number,
  formActions: UseFormReturn<Form>,
  legalEntities: LegalEntity[],
) => {
  if (!legalEntityValue) return;

  const customDataFields = [
    {
      name: `schedule.${index}.empPosition.fInternalPositionPosition`,
      enum: allEnums[EnumListKey.EMPLOYEE_POSITION],
    },
    {
      name: `schedule.${index}.employmentDetails.fEmplDetailStatus`,
      enum: allEnums[EnumListKey.EMPLOYMENT_STATUS],
    },
    {
      name: `schedule.${index}.employmentDetails.fEmplDetailJobGrade`,
      enum: allEnums[EnumListKey.JOB_GRADE],
    },
    {
      name: `schedule.${index}.employment.fEmplFixedTermReason`,
      enum: allEnums[EnumListKey.EMPL_FIXED_TERM_REASON],
    },
    {
      name: `schedule.${index}.employment.fEmplTerminationReason`,
      enum: allEnums[EnumListKey.EMPL_TERMINATION_REASON],
    },
    {
      name: `schedule.${index}.employment.fEmplType`,
      enum: allEnums[EnumListKey.EMPLOYMENT_TYPE],
    },
  ] as Field[];

  const { getValues, setValue } = formActions;

  customDataFields.forEach((field) => {
    const filteredOptions = filterActiveEnumsByCountryAndOrgUnits(
      field.enum,
      getCountryByLegalEntity(+legalEntityValue, legalEntities),
      organizationUnitValue,
    );

    //@ts-ignore
    if (!filteredOptions.find((o) => o?.code === getValues(field.name))) {
      // @ts-ignore
      setValue(field.name, '');
    }
  });

  return customDataFields;
};

export const scheduledDateFormats = {
  dotFormat: 'DD.MM.YYYY',
  dashFormat: 'YYYY-MM-DD',
};
